module.exports = __webpack_public_path__ + "img/img31.22da1d42.svg";